module.exports = __webpack_public_path__ + "static/img/hayley-emma-brooks.ad5e427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/hayley-emma-brooks.png
// module id = iR0l
// module chunks = 38